import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { IoMdClose } from "react-icons/io";
import CustomCheckbox from "../CustomFormFields/CustomCheckbox";
import withLogging from "../../logging/withLogging";
import { BsFilterCircle } from "react-icons/bs";
import moment from "moment"; // Import moment for date formatting

class TableFilter extends Component {
  state = {
    labelActive: false,
    defaultInput: "",
    statistikOptions: ["fällig", "bald fällig", "gültig"],
    isDisabled: true,
    selectedFilterName: '',
    info:[
      {filter: "bg_grundsatz", text: "Mit , können ODER Verknüpfungen (z. B. 24,25) und mit & UND Verknüpfungen (z. B. 25&26.2) genutzt werden, jedoch nicht kombiniert."},
      {filter: "geburtstag", text: "Geburstage müssen als ganzes Datum angegeben werden (TT.MM.JHJJ)."}
    ]
  };

  changeFilter = (event) => {
    let filterName = event.target.name;
    this.setState(
      {
        selectedFilterName: filterName,
        filterNameLabel: event.target.parentElement.innerText,
        isDisabled: false
      },
      () => {
        const input = document.querySelector(`input[name="filterText"], select[name="filterText"]`);
        if (input && typeof input.focus === "function") {
          input.focus();
        }
      }
    );
  };

  handleEnterKeyPressed = (event) => {
    if (event.keyCode === 13) {
      event.target.blur();

      const { statistikOptions, selectedFilterName } = this.state;
      const { onFilterChange, activeFilters } = this.props;
      const filterValue = event.target.value;

      if (this.state.filterNameLabel === "Statistik" && !statistikOptions.includes(filterValue)) {
        alert("Bitte wählen Sie eine gültige Option aus der Liste.\n\nOptionen: gültig, bald fällig, fällig");
        return; 
      }

      const newFilters = {
        ...activeFilters,
        [selectedFilterName]: filterValue,
      };
      
      onFilterChange(newFilters);
      event.target.value = "";
    }
  };

  deleteFilter = (filterKey) => {
    console.log("klick x?", filterKey);

    const { onFilterChange } = this.props;
    
    // Sende nur den zu löschenden Filter als leeren String oder null
    // Dies signalisiert der setFilter-Methode, dass dieser spezifische Filter entfernt werden soll
    const filterToDelete = { [filterKey]: null };
    
    console.log("lösche Filter:", filterToDelete);
    
    this.setState({
        filterNameLabel: undefined,
        isDisabled: true,
    });

    onFilterChange(filterToDelete);
  }

  getFilterConfigByDbName(dbName) {
    const { filterFields } = this.props;
    return filterFields?.find((element) => element.dbName === dbName);
  }

  getLabelByDbName(dbName) {
    // Special case for our new viewDate filter
    if (dbName === 'viewDate') {
        return "Status zum";
    }
    const item = this.getFilterConfigByDbName(dbName);
    return item ? item.label : dbName; // Fallback to dbName
  }

  formatFilterValue(dbName, value) {
    const item = this.getFilterConfigByDbName(dbName);
    if ((item?.filterType === "select" || item?.filterType === "chips") && item.options) {
      const option = item.options.find((opt) => String(opt.value) === String(value));
      return option ? option.label : value;
    }
    return value;
  }

  getInfoText(filterKey) {
    const infoItem = this.state.info.find(item => item.filter === filterKey);
    return infoItem ? infoItem.text : "";
  }

  getSelectedFilterConfig() {
    const { filterFields } = this.props;
    const { selectedFilterName } = this.state;
    return filterFields?.find((field) => field.dbName === selectedFilterName);
  }

  renderFilterInput(selectedFilter) {
    const { filterNameLabel, statistikOptions, isDisabled } = this.state;

    if (filterNameLabel === "Statistik") {
      return (
        <>
          <input
            list="statistikOptions"
            name="filterText"
            disabled={isDisabled}
            onKeyDown={(e) => this.handleEnterKeyPressed(e)}
            placeholder="Wähle eine Option"
            className="form-control"
          />
          <datalist id="statistikOptions">
            {statistikOptions.map((option, index) => (
              <option key={index} value={option} />
            ))}
          </datalist>
        </>
      );
    }

    if (selectedFilter?.filterType === "chips" && selectedFilter.options) {
      return (
        <div className="filterChipBox d-flex align-items-center flex-wrap gap-2">
          {selectedFilter.options.map((option, index) => (
            <button
              key={index}
              type="button"
              className={`btn btn-sm filterChip ${option.className || ""}`}
              onClick={() =>
                this.props.onFilterChange({
                  ...this.props.activeFilters,
                  [this.state.selectedFilterName]: option.value,
                })
              }
            >
              {option.label}
            </button>
          ))}
        </div>
      );
    }

    if (selectedFilter?.filterType === "select" && selectedFilter.options) {
      return (
        <Input
          type="select"
          name="filterText"
          disabled={this.state.isDisabled}
          // Filter greift sofort bei der Auswahl (Maus), nicht erst bei Enter
          onChange={(e) =>
            this.props.onFilterChange({
              ...this.props.activeFilters,
              [this.state.selectedFilterName]: e.target.value,
            })
          }
          onKeyDown={(e) => this.handleEnterKeyPressed(e)}
          defaultValue=""
        >
          <option value="" disabled>
            {selectedFilter.label} wählen
          </option>
          {selectedFilter.options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
      );
    }

    return (
      <Input
        name="filterText"
        disabled={isDisabled}
        placeholder={filterNameLabel}
        defaultValue={this.state.defaultInput}
        onKeyDown={(e) => this.handleEnterKeyPressed(e)}
      />
    );
  }

  render() {
    const { filterFields, activeFilters } = this.props;
    const selectedFilter = this.getSelectedFilterConfig();
    return (
      <div className="filterToolBox">
        <div className="row no-gutters custom-row align-items-stretch">
          <div className="col-auto">
            <InputGroup className="h-100">
              <InputGroupText id="filter"><BsFilterCircle style={{marginRight: '0.571rem'}}/> Filter:</InputGroupText>
              <Dropdown toggle={() => {}}>
                <DropdownToggle
                  data-toggle="dropdown"
                  tag="span"
                  className="form-control h-100 d-flex align-items-center"
                >
                  {this.state.filterNameLabel ?? 'Filter wählen'} 
                  <div
                    className="filter dropDownAnkle"
                    style={{ display: "inline", marginLeft: 10 }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" >
                      <path fillRule="evenodd" clipRule="evenodd" d="M1.64592 4.64601C1.69236 4.59945 1.74754 4.5625 1.80828 4.5373C1.86903 4.51209 1.93415 4.49911 1.99992 4.49911C2.06568 4.49911 2.13081 4.51209 2.19155 4.5373C2.2523 4.5625 2.30747 4.59945 2.35392 4.64601L7.99992 10.293L13.6459 4.64601C13.6924 4.59952 13.7476 4.56264 13.8083 4.53749C13.8691 4.51233 13.9342 4.49938 13.9999 4.49938C14.0657 4.49938 14.1308 4.51233 14.1915 4.53749C14.2522 4.56264 14.3074 4.59952 14.3539 4.64601C14.4004 4.6925 14.4373 4.74769 14.4624 4.80842C14.4876 4.86916 14.5005 4.93426 14.5005 5.00001C14.5005 5.06575 14.4876 5.13085 14.4624 5.19159C14.4373 5.25233 14.4004 5.30752 14.3539 5.35401L8.35392 11.354C8.30747 11.4006 8.2523 11.4375 8.19155 11.4627C8.13081 11.4879 8.06568 11.5009 7.99992 11.5009C7.93415 11.5009 7.86903 11.4879 7.80828 11.4627C7.74754 11.4375 7.69236 11.4006 7.64592 11.354L1.64592 5.35401C1.59935 5.30756 1.56241 5.25239 1.5372 5.19164C1.512 5.1309 1.49902 5.06578 1.49902 5.00001C1.49902 4.93424 1.512 4.86912 1.5372 4.80837C1.56241 4.74763 1.59935 4.69245 1.64592 4.64601Z" fill="#FF6600" />
                    </svg>
                  </div>
                </DropdownToggle>
                <DropdownMenu>
                  {filterFields ? (
                    filterFields.map((column, idx) => (
                      <FormGroup check key={idx}>
                        <CustomCheckbox
                          key={`input-${idx}`}
                          checked={activeFilters[column.dbName] ? true : false}
                          name={column.dbName}
                          onChange={this.changeFilter}
                          label={column.label}
                        />
                      </FormGroup>
                    ))
                  ) : (
                    <DropdownItem disabled>No items available</DropdownItem>
                  )}
                </DropdownMenu>
              </Dropdown>
            </InputGroup>
          </div>
          <div className="col">
            {this.renderFilterInput(selectedFilter)}
          </div>
        </div>
        {this.getInfoText(this.state.selectedFilterName) && (
          <div className="row infoBox">
            <div className="col-12">
              <div role="alert" className="mt-2 alert alert-info alert-dismissible fade show" style={{fontSize: '0.8rem'}}>
                {this.getInfoText(this.state.selectedFilterName)}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="row">
          {/* Sortiere die Filter so, dass viewDate immer der Erste ist */}
          {(() => {
            const keys = Object.keys(activeFilters);
            const viewDateIndex = keys.indexOf('viewDate');
            let sortedKeys = keys;
            
            // Wenn viewDate vorhanden ist, verschiebe es an den Anfang
            if (viewDateIndex > -1) {
              sortedKeys = ['viewDate', ...keys.filter(key => key !== 'viewDate')];
            }
            
            return sortedKeys.map((key) => {
              let value = activeFilters[key];
              // Format date for display
              if (key === 'viewDate') {
                  value = moment(value).format('MMM YY');
              } else {
                  value = this.formatFilterValue(key, value);
              }
              
              // Spezielle Behandlung fuer viewDate Filter
              const isViewDate = key === 'viewDate';
              const filterBoxClass = isViewDate 
                ? "filterBox viewDateFilter" 
                : "filterBox";
                
              return (
                <div className="col-auto" key={key}>
                  <span
                    className={filterBoxClass}
                  >
                    {this.getLabelByDbName(key) + ": " + value}
                    {!isViewDate && (
                      <i className="icon" onClick={() => this.deleteFilter(key)}>
                        <IoMdClose />
                      </i>
                    )}
                  </span>
                </div>
              );
            });
          })()}
        </div>
      </div>
    );
  }
}

export default withLogging(TableFilter);

TableFilter.propTypes = {
  onFilterChange: PropTypes.func.isRequired,
  filterFields: PropTypes.array.isRequired,
  activeFilters: PropTypes.object.isRequired,
};
